import { render, staticRenderFns } from "./batData.vue?vue&type=template&id=4757552a&scoped=true&"
import script from "./batData.vue?vue&type=script&lang=js&"
export * from "./batData.vue?vue&type=script&lang=js&"
import style0 from "./batData.vue?vue&type=style&index=0&id=4757552a&prod&lang=less&scoped=true&"
import style1 from "./batData.vue?vue&type=style&index=1&id=4757552a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757552a",
  null
  
)

export default component.exports